import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { Query } from 'react-apollo';
import { func, object } from 'prop-types';
// import cn from 'classnames';
import { ROUTE_CONTRACTS, ROUTE_CONTRACTS_DETAIL } from 'common/constants';
import { FETCH_ALL_FIELDS_AND_STORAGES } from 'api/storage';
import { ContractForm } from 'containers';
import { FieldWrapper, LevelNav, ErrorBoundary } from 'common/components';
import { getFieldsListFromData } from 'api/util';
import { base64_decode } from 'util/base64';

export class ContractEdit extends Component {
  static displayName = 'ContractEdit';

  static propTypes = {
    closeForm: func,
    match: object,
  };

  render() {
    const {
      closeForm,
      match: {
        params: { encodedId },
      },
    } = this.props;

    const ID = (encodedId && base64_decode(encodedId)) || 'add';
    const mode = encodedId ? 'edit' : 'add';

    return (
      <ErrorBoundary>
        <Query
          query={FETCH_ALL_FIELDS_AND_STORAGES}
          fetchPolicy="cache-and-network"
          variables={{ season: new Date().getFullYear(), active: true }}
        >
          {({ loading, error, data }) => {
            if (loading || error) return null; // handle side effects here in the future.
            const { getAllStorages: storages } = data;

            return (
              <FieldWrapper
                field={{ fields: getFieldsListFromData(data) }}
                storages={storages}
                theme={['white']}
                nav={
                  <LevelNav
                    nav={{
                      left: {
                        label: <span className={'visible--desktop'}>Back</span>,
                        action: () => closeForm(),
                      },
                      center: { label: `${mode} Contract` },
                      right: null,
                    }}
                  />
                }
              >
                <ContractForm id={ID} closeForm={closeForm} />
              </FieldWrapper>
            );
          }}
        </Query>
      </ErrorBoundary>
    );
  }
}

const mapDispatch = (dispatch, props) => ({
  closeForm: () => {
    const {
      match: {
        params: { encodedId },
      },
    } = props;
    return dispatch(
      push(
        encodedId ? `${ROUTE_CONTRACTS_DETAIL}/${encodedId}` : ROUTE_CONTRACTS
      )
    );
  },
});

export default connect(
  null,
  mapDispatch
)(ContractEdit);



// WEBPACK FOOTER //
// ./src/pages/Contract/Edit/index.js